import { Flex } from 'antd';
import RBCountryFilter from 'components/UniversalFilters/RBCountryFilter';
import SeasonIndexFilter from 'components/UniversalFilters/SeasonIndexFilter';
import { useTranslation } from 'react-i18next';
import HeaderCard from '../../../components/HeaderCard';

const Header = ({
  country,
  seasonIndex,
  onCountryChange,
  onSeasonIndexChange,
}) => {
  const { t } = useTranslation();
  const filters = (
    <Flex gap={20} align="center" wrap="wrap">
      <RBCountryFilter selectedCountry={country} onChange={onCountryChange} />
      <SeasonIndexFilter
        country={country}
        seasonIndex={seasonIndex}
        setSeasonIndex={onSeasonIndexChange}
      />
    </Flex>
  );

  return (
    <HeaderCard
      headerLabel={t('awdMaps.header')}
      headerInfo={t('awdMaps.subHeader')}
      filters={filters}
    />
  );
};

export default Header;
